import { FC } from 'react';
import { IoIosShirt } from "react-icons/io";

type Props = {
  positions: { x: number; y: number; };
  answer: { title: string; percent: number; };
  size?: 'small' | 'large' | 'compact';
  color: string;
}

const PlayerSpot: FC<Props> = ({ positions, answer, size = 'small', color }) => (
  <div
    className="absolute text-white text-xs text-center"
    style={{
      left: `${positions.x}%`,
      top: `${positions.y}%`,
      transform: 'translate(-50%, -50%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <div className="flex items-center gap-1">
      <p
        className={`text-black font-bold bg-white ${size === 'large' ? 'p-2' : 'px-1 py-0.5'} rounded-full`}
        style={{ fontSize: size === 'large' ? 22 : size === 'compact' ? 8 : 11, order: positions.x < 50 ? 0 : 1 }}
      >
        {`${answer.percent}%`}
      </p>
      <IoIosShirt className="drop-shadow" style={{ color, fontSize: size === 'large' ? 72 : size === 'compact' ? 20 : 48 }} />
    </div>
    <p className={`text-black font-bold bg-white ${size === 'large' ? 'p-2' : 'px-2'} rounded-full mt-0.5 whitespace-nowrap`} style={{ fontSize: size === 'large' ? 22 : size === 'compact' ? 8 : 11, maxWidth: size === 'compact' ? '70px' : size === 'small' ? '130px' : 'auto', textOverflow: 'ellipsis', overflow: 'hidden' }}>
      {answer.title}
    </p>
  </div>
);

export default PlayerSpot;
